if (!customElements.get("td-product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('td-product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initSwiper();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initSwiper() {
      const swiperContainers = this.querySelectorAll('[data-swiper]');
      swiperContainers.forEach(container => {
        const swiperOptions = JSON.parse(container.closest('swiper-slider').dataset.swiperOptions);
        new Swiper(container, swiperOptions);
      });
    }
  }
  customElements.define('td-product-recommendations', ProductRecommendations);
}
